export const ITEM_TYPES = {
  Buy: 0,
  Sell: 1,
};

export const PURPOSE_TYPES = {
  ForPlay: 0,
  ForSale: 1,
};

export const CURRENCIES = [
  "USD",
  "CNY",
  "EUR",
  "CAD",
  "AUD",
  "JPY",
  "GBP",
  "NZD",
  "RUB",
  "TRY",
  "PHP",
  "CZK",
  "CHF",
  "BGN",
  "BRL",
  "IDR",
];

export const EXCHANGE_RATES = {
  USD: 1.209826,
  CNY: 7.74132,
  EUR: 1,
  CAD: 1.472691,
  AUD: 1.571928,
  JPY: 132.782104,
  GBP: 0.858124,
  NZD: 1.698705,
  RUB: 87.357967,
  TRY: 10.123487,
  PHP: 57.806106,
  CZK: 25.392805,
  CHF: 1.088002,
  BGN: 1.953863,
  BRL: 6.193831,
  IDR: 17204.031141,
};